import React, {useEffect, useRef} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import HourTypeInput from "../../../../components/reports/time-period-input/hour-type-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {useQuery} from "@tanstack/react-query";
import LanesService from "../../../../services/web/lanes-service.js";

const Filters = ({ setFilters, filters, trafficFlowPointVehicleTypes }) => {
    const { trafficFlowPointCapturePlaces } = useReportFiltersFetch({ fetchTrafficFlowPointCapturePlaces: true });
    const selectedPclId = filters.pcl?.value;

    const hasValue = (value) => value !== null && value !== undefined && value !== "";
    const hasPcl = hasValue(selectedPclId);
    const autoSelectedPclIdRef = useRef(null);

    const {
        data: trafficFlowPointLanes = [],
        isLoading: isLoadingTrafficFlowPointLanes
    } = useQuery({
        queryKey: ["traffic-flow-point-lanes", selectedPclId ?? ""],
        queryFn: () => LanesService.getLaneByCapturePoint(selectedPclId),
        enabled: hasPcl,
    });

    useEffect(() => {
        if (!hasPcl) {
            autoSelectedPclIdRef.current = null;
            return;
        }

        if (isLoadingTrafficFlowPointLanes || trafficFlowPointLanes.length === 0 || autoSelectedPclIdRef.current === selectedPclId) return;

        setFilters(prev => {
            if (prev.pcl?.value !== selectedPclId) return prev;
            autoSelectedPclIdRef.current = selectedPclId;

            if (prev.lanes?.length > 0) return prev;
            return {...prev, lanes: trafficFlowPointLanes};
        });
    }, [hasPcl, isLoadingTrafficFlowPointLanes, selectedPclId, setFilters, trafficFlowPointLanes]);

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <HourTypeInput filters={filters} setFilters={setFilters}></HourTypeInput>

                    <SelectComponent
                        label="Ponto de coleta *"
                        wrapValues={true}
                        options={trafficFlowPointCapturePlaces}
                        value={filters.pcl ?? ""}
                        onChange={(value) => setFilters(prev => ({...prev, pcl: value, lanes: []}))}
                        instanceId="pcl"
                        classNameWrapper={"w-full"}
                        isClearable={true}
                    />

                    <SelectComponent
                        id={'lanes'}
                        label="Câmeras"
                        isMulti={true}
                        wrapValues={true}
                        options={trafficFlowPointLanes}
                        value={filters.lanes}
                        onChange={(value) => setFilters(prev => ({...prev, lanes: value}))}
                        classNameWrapper={"w-full"}
                        isClearable={true}
                        isDisabled={!hasPcl}
                        isLoading={isLoadingTrafficFlowPointLanes}
                    />

                    <SelectComponent
                        label="Tipo de veículo"
                        isMulti={true}
                        wrapValues={true}
                        options={trafficFlowPointVehicleTypes}
                        value={filters.vehicleTypes}
                        onChange={(value) => setFilters(prev => ({...prev, vehicleTypes: value}))}
                        instanceId="vehicleTypes"
                        classNameWrapper={"w-full"}
                        isClearable={true}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;